import React, { useState } from 'react';
import { Tabs } from 'antd';
import { CodeOutlined, SettingOutlined } from '@ant-design/icons';
import AllSnippets from './AllSnippets';
import ActiveInactiveControl from './ActiveInactiveControl';
import '../super-admin.css';

const SnippetsManagement = () => {
  const [activeTab, setActiveTab] = useState('all');

  const items = [
    {
      key: 'all',
      label: (
        <span>
          <CodeOutlined />
          All Snippets
        </span>
      ),
      children: <AllSnippets />,
    },
    {
      key: 'control',
      label: (
        <span>
          <SettingOutlined />
          Active / Inactive Control
        </span>
      ),
      children: <ActiveInactiveControl />,
    },
  ];

  return (
    <div className="sa-content">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
        style={{ marginBottom: 24 }}
      />
    </div>
  );
};

export default SnippetsManagement;
